import { useQuery } from "@/api/swr/useQuery";
import { answerCategorySchema } from "@/schema/app/assessment/answerCategory";

type Config = Parameters<typeof useQuery<typeof answerCategorySchema>>[2];

export function useGetAnswerCategory(categoryId: string, config?: Config) {
  return useQuery(
    answerCategorySchema,
    `/app/assessment/answer_categories/${categoryId}`,
    config,
  );
}
